import { AccountStatus, UserPermissions, UserType } from "healthex-common/user.dtos";
import { filterNull, willNeverHappen } from "healthex-common/utils";
export function describeGlobalAdminUserStatus(status) {
    switch (status) {
        case AccountStatus.ACTIVE:
            return "Active";
        case AccountStatus.INVITED:
            return "Invited";
        case AccountStatus.LOCKED:
            return "Locked";
        case AccountStatus.ADMIN_PASSWORD_RESET:
            return "Password reset required";
        default:
            return willNeverHappen(status);
    }
}
export function describeGlobalAdminUserPermissions(user) {
    switch (user.type) {
        case UserType.HEALTHCARE_ORGANIZATION:
            return filterNull(user.permissions.map((permission) => {
                switch (permission) {
                    case UserPermissions.ORG_ADMIN:
                        return "IT admin";
                    case UserPermissions.RESEARCH_ADMIN:
                        return "Research admin";
                    case UserPermissions.RESEARCHER:
                        return "Researcher";
                    case UserPermissions.PROVIDER:
                        return "Provider";
                    default:
                        return null;
                }
            }));
        case UserType.EXTERNAL_RESEARCHER:
            return filterNull(user.permissions.map((permission) => {
                switch (permission) {
                    case UserPermissions.ORG_ADMIN:
                        return "Admin";
                    case UserPermissions.RESEARCHER:
                        return "User";
                    default:
                        return null;
                }
            }));
        case UserType.SERVICE_PROVIDER:
            return filterNull(user.permissions.map((permission) => {
                switch (permission) {
                    case UserPermissions.ORG_ADMIN:
                        return "Admin";
                    case UserPermissions.GLOBAL_PROVISIONING:
                        return "System-wide Provisioning";
                    default:
                        return null;
                }
            }));
        default:
            return willNeverHappen(user);
    }
}
